var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 43,
    viewBox: "0 0 66 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.754 42.5041C59.1525 42.5041 66 35.6731 66 27.2581C66 19.4701 60.027 12.9526 52.437 12.1111C52.2389 8.79455 53.4105 5.64309 55.968 2.72256C56.562 2.046 56.496 1.00659 55.803 0.396003C55.4895 0.132052 55.11 1.81215e-05 54.7139 1.80868e-05C54.3014 1.80508e-05 53.8889 0.148566 53.5754 0.462066C53.427 0.544551 53.0804 0.660071 52.8825 0.742537C52.569 0.858054 52.272 0.957038 52.074 1.07255C45.4245 4.43852 40.326 9.42156 37.7024 15.0976C36.1845 18.3976 35.3429 22.2585 35.3429 25.8886C35.3429 26.3835 35.3595 26.8786 35.3925 27.3736C35.937 35.7226 42.834 42.5041 50.754 42.5041Z",
    fill: "#EF519D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.411 42.5041C23.8094 42.5041 30.657 35.6731 30.657 27.2581C30.657 19.4701 24.684 12.9526 17.0774 12.1111C16.8959 8.79455 18.0675 5.64309 20.6084 2.72256C21.2189 2.046 21.1364 1.00659 20.46 0.396003C20.1465 0.132052 19.7504 1.812e-05 19.3709 1.80868e-05C18.9584 1.80508e-05 18.5459 0.148566 18.2159 0.462066C18.084 0.544551 17.7374 0.660071 17.5394 0.742537C17.2094 0.858054 16.9289 0.957038 16.7144 1.07255C10.0814 4.43852 4.98294 9.42156 2.35941 15.0976C0.841437 18.3976 -8.02461e-05 22.2585 -8.05634e-05 25.8886C-8.06067e-05 26.3835 0.0164351 26.8786 0.0494684 27.3736C0.593903 35.7226 7.47446 42.5041 15.411 42.5041Z",
    fill: "#EF519D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotes);
export default __webpack_public_path__ + "static/media/icon-quotes.60fe5f4d2586962df4e67ac28a36e982.svg";
export { ForwardRef as ReactComponent };